import _ from "lodash";
import {getCurrencySymbol} from "../../../../../_helpers";

export function buildMetricsDetailsUrl(campaign, pageFilter, params) {
    return (`/proactive-metrics-details?campaignIds=${_.get(campaign, 'id')}&pageFilter=${pageFilter}&organizationId=${_.get(campaign, 'organizationId')}&source=${_.get(campaign, 'source')}`);
}

export function getCampaignRevenue(revenue) {
    const amount = _.get(revenue, 'amount') || 0
    const currencySymbol = getCurrencySymbol(_.get(revenue, 'currency'))

    if (!revenue || amount === 0) return "-";

    return `${currencySymbol}${amount.toLocaleString()}`;
}

export function formatCurrency(amount) {
    return amount ? `$${amount.toLocaleString('en-US')}` : '-';
}

export function formatRevenue(amount) {
    return amount ? `$${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '-';
}

export const RETAIN_CAMPAIGNS = "retainCampaigns";
export const ACQUIRE_CAMPAIGNS = "acquireCampaigns";

export const RETAIN_VIEW_REVENUE = "revenue";
export const RETAIN_VIEW_ENGAGEMENT = "engagement";
